import restGql from 'graphql-tag';

import {type Plan} from '../helpers/plan-types';

export type CreatePlanInput = {plan: Plan};
export type CreatePlanVariables = {input: CreatePlanInput};

export const CreatePlan = restGql`#graphql
    mutation CreatePlan(
        $input: CreatePlanInput!
    ) {
        createPlan(input: $input) @rest(
            type: "CreatePlan",
            method: "POST",
            path: "/v2/plans?preview=false&version=2",
            bodyKey: "input"
        ) {
            plan
        }
    }
`;
